import { useStatsigDynamicB2BConfig } from '@src/experiments/statsig-integration/use-statsig-dynamic-config.hook'

import { ProductOfferMessage } from '../productOfferMessage'

export default function B2BSelfServeProductOfferMessage({ showNewPdpDesignV2 }: { showNewPdpDesignV2?: boolean }) {
  const b2bSelfServeOfferMessage = useStatsigDynamicB2BConfig<string>('pdpSelfServeOfferMessage')

  return (
    <ProductOfferMessage
      hideOfferMessage={!b2bSelfServeOfferMessage}
      offerMessageFromPC={b2bSelfServeOfferMessage}
      showNewPdpDesignV2={showNewPdpDesignV2}
    />
  )
}
